import OrganizationTab from './OrganizationTab'
export default OrganizationTab


// WEBPACK FOOTER //
// ./src/components/ChannelTabs/HWTab/MappingTabs/OrganizationTab/index.js